import React from 'react';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { PageSubmitButton } from 'Views/Page/Components/PageSubmitButton/PageSubmitButton';
import fr from 'facet-rest';
import { ImageRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/ImageRel';
import { FDStack } from '@facet-wealth/design';
import useMobileLayout from 'Hooks/useMobileLayout';
import { LayoutPaperActions, WizardLayout } from '../Components';

export const Layout = () => {
  const { pageContentResource } = usePageContentContext();
  const isMobile = useMobileLayout();

  return (
    <WizardLayout
      aboveTitle={pageContentResource.withRelationship(fr.relationships.image.name, (rel) => {
        return (
          <FDStack padding={isMobile ? 4 : 8}>
            <ImageRel relationship={rel} width={'100%'} />
          </FDStack>
        );
      }, () => null)}
    >
      <LayoutPaperActions>
        <PageSubmitButton resource={pageContentResource} />
      </LayoutPaperActions>
    </WizardLayout>
  );
};
